module.exports = __webpack_public_path__ + "static/loader25-949be4872b5965d7598b6d6eee4b7554.gif";